"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SurveyStatuses = void 0;
/**
 * Should be kept in sync with the backend
 */
var SurveyStatuses = /*#__PURE__*/function (SurveyStatuses) {
  SurveyStatuses[SurveyStatuses["Ongoing"] = 1] = "Ongoing";
  SurveyStatuses[SurveyStatuses["Finished"] = 2] = "Finished";
  SurveyStatuses[SurveyStatuses["Archived"] = 3] = "Archived";
  return SurveyStatuses;
}({});
/**
 * Specific patient survey that may include SurveyDto and PatientAnswerDto[]
 */
exports.SurveyStatuses = SurveyStatuses;